"use client";

import { Button } from "../button";
import { Icon } from "../icon";

type GoBackProps = {
  onClick?: () => void;
  className?: string;
  label?: string;
  size?: "sm" | "md" | "lg";
};

export function GoBack({ onClick, className, label, size }: GoBackProps) {
  return (
    <Button
      onClick={onClick}
      variant="ghost"
      className={`text-brand-primary-dark rounded-none border-none px-0 py-0 shadow-none hover:bg-transparent hover:shadow-none ${className || ""}`}
    >
      <Icon name="times" size="md" className="text-system-grayscale-70" />
    </Button>
  );
}
